import { gql } from '@apollo/client';
import { ProgressPortraitResponse } from '../model/ProgressPortraitResponse';
import parse from 'date-fns/parse';
import { ProgressPortrait } from '../model/ProgressPortrait';

export const progressPortraitMetricsFragment = gql`
  fragment ProgressPortraitMetricsFragment on ProgressPortraitMetrics {
    vinelandAssessmentDate
    associatedTo
    vinelands {
      id
      vineland_Assessment_Date__c
      ABC_Score__c
      ABC_Adaptive_Level__c
      ABC_Percentile_Rank__c
      ABC_Strength_or_Weakness__c
      communication_Score__c
      communication_Adaptive_Level__c
      communication_Percentile_Rank__c
      communication_Strength_or_Weakness__c
      DLS_Score__c
      DLS_Adaptive_Level__c
      DLS_Percentile_Rank__c
      DLS_Strength_or_Weakness__c
      socialization_Score__c
      socialization_Adaptive_Level__c
      socialization_Percentile_Rank__c
      socialization_Strength_or_Weakness__c
      motor_Skills_Score__c
      motor_Skills_Adaptive_Level__c
      motor_Skills_Percentile_Rank__c
      motor_Skills_Strength_or_Weakness__c
      comm_Receptive_Score__c
      comm_Receptive_Adaptive_Level__c
      comm_Receptive_Age_Equivalent__c
      comm_Expressive_Score__c
      comm_Expressive_Adaptive_Level__c
      comm_Expressive_Age_Equivalent__c
      comm_Written_Score__c
      comm_Written_Adaptive_Level__c
      comm_Written_Age_Equivalent__c
      DLS_Personal_Score__c
      DLS_Personal_Adaptive_Level__c
      DLS_Personal_Age_Equivalent__c
      DLS_Domestic_Score__c
      DLS_Domestic_Adaptive_Level__c
      DLS_Domestic_Age_Equivalent__c
      DLS_Community_Score__c
      DLS_Community_Adaptive_Level__c
      DLS_Community_Age_Equivalent__c
      SL_Interpersonal_Score__c
      SL_Interpersonal_Adaptive_Level__c
      SL_Interpersonal_Age_Equivalent__c
      SL_Play_Score__c
      SL_Play_Adaptive_Level__c
      SL_Play_Age_Equivalent__c
      SL_Coping_Score__c
      SL_Coping_Adaptive_Level__c
      SL_Coping_Age_Equivalent__c
      gross_Motor_Score__c
      gross_Motor_Adaptive_Level__c
      gross_Motor_Age_Equivalent__c
      fine_Motor_Score__c
      fine_Motor_Adaptive_Level__c
      fine_Motor_Age_Equivalent__c
      MBI_Internalizing_Score__c
      MBI_Internalizing_Adaptive_Level__c
      MBI_Externalizing_Score__c
      MBI_Externalizing_Adaptive_Level__c
      gets_fixated_on_objects__c
      gets_fixated_on_objects_other__c
      talks_about_hearing_voices__c
      talks_about_hearing_voices_other__c
      harms_himself_herself__c
      harms_himself_herself_other__c
      uses_strange_or_repetitive_speech__c
      uses_strange_speech_other__c
      loses_awareness__c
      loses_awareness_other__c
      repeats_physical_movements__c
      repeats_physical_movements_other__c
      has_toileting_accidents__c
      has_toileting_accidents_other__c
      eats_non_food_items__c
      eats_non_food_items_other__c
      engages_in_compulsive_behavior__c
      engages_in_compulsive_behavior_other__c
      shows_far_more_interest_in_weapons__c
      shows_interest_in_weapons_other__c
      harms_animals__c
      harms_animals_other__c
      has_beliefs_that_are_not_true__c
      has_beliefs_that_are_not_true_other__c
      gets_fixated_on_a_particular_topic__c
      gets_fixated_on_a_part_topic_other__c
      talks_about_killing_himself_herself__c
      talks_about_killing_oneself_other__c
      has_no_response_to_pain__c
      has_no_response_to_pain_other__c
      wanders_or_darts_away__c
      wanders_or_darts_away_other__c
      threatens_to_hurt_or_kill_someone__c
      threatens_to_hurt_so_other__c
      is_tricked_by_others_causing_harm__c
      is_tricked_causing_harm_other__c
      gets_fixated_on_a_person__c
      gets_fixated_on_a_person_other__c
      engages_in_unwanted_sexual_behavior__c
      engages_in_unwant_sex_behav_other__c
      vineland_3_Assessment__c
      name_Of_Respondent__c
    }
    goals {
      reportDate
      percentage
      totalGoals
      goalsMet
      totalCaregiverTrainingGoals
      caregiverTrainingGoalsMet
      newGoalsForNextReportingPeriod
      clientExhibitDangerousBehaviour
      hasPhysicalHarm
      physicalHarmIntensity
      physicalHarmFrequency
      hasSelfInjurious
      selfInjuriousIntensity
      selfInjuriousFrequency
      hasDangerousElopement
      dangerousElopementIntensity
      dangerousElopementFrequency
      hasSexuallyInappropriate
      sexuallyInappropriateIntensity
      sexuallyInappropriateFrequency
      hasPropertyDestruction
      propertyDestructionIntensity
      propertyDestructionFrequency
      hasEatingFoodItems
      eatingFoodItemsIntensity
      eatingFoodItemsFrequency
      hasConnectedElimination
      connectedEliminationIntensity
      connectedEliminationFrequency
      hasOtherBehaviors
      otherBehaviorsIntensity
      otherBehaviorsFrequency
    }
    psss {
      id
      assessment_Date__c
      total_Stress__c
      name_Of_Respondent__c
    }
    sipas {
      id
      adolescent_Domain__c
      adolescent_Domain_Inter__c
      adolescent_Domain_Mis_Resp__c
      adolescent_Parent_Relationship_Domain__c
      APRD_Inter__c
      APRD_Mis_Resp__c
      delinquency_Antisocial__c
      DEL_Inter__c
      DEL_Mis_Resp__c
      ACH_Mis_Resp__c
      failure_to_Achieve_or_Persevere__c
      ACH_Inter__c
      incompetence_Guilt__c
      INC_Inter__c
      INC_Mis_Resp__c
      index_of_Total_Parenting_Stress__c
      life_Restrictions__c
      LFR_Inter__c
      LFR_Mis_Resp__c
      life_Stressors__c
      LS_Inter__c
      LS_Mis_Resp__c
      MEL_Mis_Resp__c
      moodiness_Emotional_Lability__c
      parent_Domain__c
      PD_Inter__c
      PD_Mis_Resp__c
      REL_Inter__c
      REL_Mis_Resp__c
      relationship_With_Spouse_Partner__c
      SIPA_Assessment_Date__c
      social_Alienation__c
      SOC_Inter__c
      SOC_Mis_Resp__c
      social_Isolation_Withdrawal__c
      ISO_Inter__c
      ISO_Mis_Resp__c
      TS_Inter__c
      TS_Mis_Resp__c
      MEL_Inter__c
      name_Of_Respondent__c
    }
    psi4s {
      id
      assessment_Date__c
      defensive_Responding_Score__c
      difficult_Child__c
      parent_Child_Dysfunctional_Interaction__c
      parental_Distress__c
      total_Stress__c
      protocol_Validity__c
      name_Of_Respondent__c
    }
    pcs {
      id
      assessment_Date__c
      survey_not_completed__c
      helpful_Training__c
      manage_Behavior__c
      teach_New_Skills__c
      positive_Effect__c
      parent_Confidence_Survey__c
      parent_Confidence_Score__c
      name_Of_Respondent__c
    }
    wbss {
      id
      assessment_Date__c
      total_Stress__c
      well_being_Scale_Type__c
      name_Of_Respondent__c
    }
    tiis {
      id
      assessment_Date__c
      total_Score__c
      treatment_Impact_Indicator_Type__c
      name_Of_Respondent__c
    }
  }
`;

const DATE_TIME_FIELDS = [
  'vinelandAssessmentDate',
  'vineland_Assessment_Date__c',
  'reportDate',
  'assessment_Date__c',
  'SIPA_Assessment_Date__c',
];
export const fromProgressPortraitJson = (
  json: ProgressPortraitResponse,
): ProgressPortrait => {
  return JSON.parse(JSON.stringify(json), (key, value) => {
    if (DATE_TIME_FIELDS.includes(key) && value) {
      return parse(value, 'yyyy-MM-dd', new Date());
    }
    return value;
  });
};
